import Api from '../api'
export default ({
  state: {
    salesHoldLists: [],
    salesChildHeaderLists: [],
    salesChildDeletedHeaderLists: [],
    unSettleSalesChildHeaderLists: [],
    unPaidSalesLists: [],
    countersList: [],
    rewardPointLists: [],
    itemInHistoryLists: [],
    dublicateSalesChildHeaderLists: [],
    posCustomerLists: []
  },
  mutations: {
    SALES_HOLD_LIST(state, salesHoldList) {
      state.salesHoldLists = salesHoldList
    },
    SALES_CHILD_HEADER_LIST(state, salesChildHeaderList) {
      state.salesChildHeaderLists = salesChildHeaderList
    },
    SALES_CHILD_DUBLICATE_HEADER_LIST(state, dublicateSalesChildHeaderList) {
      state.dublicateSalesChildHeaderLists = dublicateSalesChildHeaderList
    },
    SALES_CHILD_DELETED_HEADER_LIST(state, salesChildDeletedHeaderList) {
      state.salesChildDeletedHeaderLists = salesChildDeletedHeaderList
    },
    UNSETTLE_SALES_CHILD_HEADER_LIST(state, unSettleSalesChildHeaderList) {
      state.unSettleSalesChildHeaderLists = unSettleSalesChildHeaderList
    },
    UNPAID_SALES_LIST(state, unPaidSalesList) {
      state.unPaidSalesLists = unPaidSalesList
    },
    COUNTER_LIST(state, getCounterList) {
      state.countersList = getCounterList
    },
    POS_CUSTOMER_LIST(state, posCustomerList) {
      state.posCustomerLists = posCustomerList
    },
    REWARD_POINT_LIST(state, rewardPointList) {
      state.rewardPointLists = rewardPointList
    },
    ADD_COUNTER(state, newCounter) {
      let counter = state.countersList.concat(newCounter)
      state.countersList = counter
    },
    ADD_REWARD_POINT(state, reWardPoint) {
      let reward = state.rewardPointLists.concat(reWardPoint)
      state.rewardPointLists = reward
    },
    UPDATE_COUNTER(state, updatedCounter) {
      state.countersList = state.countersList.map(counter => counter.id !== updatedCounter.id ? counter : {...counter, ...updatedCounter})
    },
    UPDATE_REWARD_POINT(state, updatedCounter) {
      state.rewardPointLists = state.rewardPointLists.map(counter => counter.id !== updatedCounter.id ? counter : {...counter, ...updatedCounter})
    },
    DELETE_COUNTER(state, deleteCounter) {
      let counter = state.countersList.filter(a => a.id !== deleteCounter.id)
      state.countersList = counter
    },
    DELETE_REWARD_POINT(state, deleteRewardPoint) {
      let counter = state.rewardPointLists.filter(a => a.id !== deleteRewardPoint.id)
      state.rewardPointLists = counter
    },
    DELETE_POS_SALES (state, posSales) {
      let posSale = state.unSettleSalesChildHeaderLists.filter(a => a.id !== posSales.id)
      state.unSettleSalesChildHeaderLists = posSale
    },
    ITEM_IN_HISTORY_LIST(state, itemInHistoryList) {
      state.itemInHistoryLists = itemInHistoryList
    }
  },
  actions: {
    async loadSalesHoldLists({ commit }, date) {
      let response = await Api.request('get', '/pos/salesHoldList/' + this.state.organisationid + '/' + this.state.fyId + '/' + date.fromDate + '/' + date.toDate + '')
      let responseValue = response.data.data
      commit('SALES_HOLD_LIST', responseValue)
      return response
    },
    async loadSalesChildHeaderLists({ commit }, date) {
      let response = await Api.request('get', '/pos/salesChildHeaderList/' + this.state.organisationid + '/' + this.state.fyId + '/' + date.fromDate + '/' + date.toDate + '/' + date.type + '/' + this.getters.userId + '/' + date.warehouse + '')
      let responseValue = response.data.data
      commit('SALES_CHILD_HEADER_LIST', responseValue)
      return response
    },
    async loadSalesChildHeaderByCustomerLists({ commit }, date) {
      let response = await Api.request('get', '/pos/salesChildHeaderListByCustomer/' + this.state.organisationid + '/' + this.state.fyId + '/' + date.fromDate + '/' + date.toDate + '/' + date.type + '/' + this.getters.userId + '/' + date.customerId + '')
      let responseValue = response.data.data
      commit('SALES_CHILD_HEADER_LIST', responseValue)
      return response
    },
    async loadSalesChildDeleteHeaderLists({ commit }, date) {
      let response = await Api.request('get', '/pos/deletedSalesReport/' + this.state.organisationid + '/' + this.state.fyId + '/' + this.getters.userId + '/' + date.warehouse + '/' + date.fromDate + '/' + date.toDate + '')
      let responseValue = response.data.data
      commit('SALES_CHILD_DELETED_HEADER_LIST', responseValue)
      return response
    },
    async loadSalesChildDublicateHeaderLists({ commit }) {
      let response = await Api.request('get', '/pos/returnDublicatePosSales/' + this.state.organisationid + '/' + this.state.fyId + '/' + this.getters.userId)
      let responseValue = response.data.data
      commit('SALES_CHILD_DUBLICATE_HEADER_LIST', responseValue)
      return response
    },
    async loadUnSettleSalesChildHeaderLists({ commit }, date) {
      let response = await Api.request('get', '/pos/unSettleSalesChildHeaderList/' + this.state.organisationid + '/' + this.state.fyId + '/' + date.fromDate + '/' + date.fromDate + '/' + this.getters.userId + '/' + date.warehouse + '')
      let responseValue = response.data.data
      commit('UNSETTLE_SALES_CHILD_HEADER_LIST', responseValue)
      return response
    },
    async loadUnpaidLists({ commit }, date) {
      let response = await Api.request('get', '/pos/unPiadSalesReport/' + this.state.organisationid + '/' + this.state.fyId + '/' + this.getters.userId + '/' + date.warehouse + '')
      let responseValue = response.data.data
      commit('UNPAID_SALES_LIST', responseValue)
      return response
    },
    async sendDeliverySms({ commit }, date) {
      let response = await Api.request('get', '/pos/sendSmsForDelivery/' + this.state.organisationid + '/' + this.getters.userId + '/' + date.idsForSms + '/' + date.deliveryNumber + '')
      // let responseValue = response.data.data
      return response.data.data
    },
    async sendDeliveryMail({ commit }, date) {
      let response = await Api.request('get', '/pos/sendMailForDelivery/' + this.state.organisationid + '/' + this.getters.userId + '/' + date.idsForSms + '/' + date.deliveryNumber + '')
      // let responseValue = response.data.data
      return response.data.data
    },
    async settleSales({ commit }, date) {
      let response = await Api.request('post', '/pos/dayEndSettlement/' + this.state.organisationid + '/' + this.getters.userId + '/' + this.state.fyId + '/' + date.fromDate + '', date)
    // let responseValue = response.data.data
      if (response.data.status === 'SUCCESS') {
      // commit('ADD_SALES_ORDER', responseValue)
      }
      return response
    },
    async savePOSEntry({commit}, posItem) {
      let response = await Api.request('post', '/pos/savePos/' + this.state.organisationid + '/' + this.getters.userId + '/' + this.state.fyId, posItem)
      // // debugger
      return response
    },
    async updatePOSEntry({commit}, posItem) {
      let response = await Api.request('put', '/pos/updatePos/' + posItem.id + '/' + this.getters.userId, posItem)
      // // debugger
      return response
    },
    // CounterMethods
    async loadCountersList({commit}) {
      let response = await Api.request('get', '/pos/counterList/' + this.state.organisationid)
      commit('COUNTER_LIST', response.data.data)
      // // debugger
      return
    },
    async loadPosCustomerList({commit}) {
      let response = await Api.request('get', '/pos/counterList/' + this.state.organisationid)
      commit('POS_CUSTOMER_LIST', response.data.data)
      // // debugger
      return
    },
    async loadRewardPointList({commit}) {
      let response = await Api.request('get', '/pos/returnRewardPointLists/' + this.state.organisationid + '/' + this.getters.userId)
      commit('REWARD_POINT_LIST', response.data.data)
      // // debugger
      return
    },
    async saveCounter({commit}, counter) {
      let response = await Api.request('post', '/pos/createPosCounter/' + this.state.organisationid + '/' + this.getters.userId, counter)
      if (response.data.status === 'SUCCESS') {
        commit('ADD_COUNTER', response.data.data)
      }
      return response
    },
    async saveRewardPoints({commit}, counter) {
      let response = await Api.request('post', '/pos/createRewardPoints/' + this.state.organisationid + '/' + this.getters.userId, counter)
      if (response.data.status === 'SUCCESS') {
        commit('ADD_REWARD_POINT', response.data.data)
      }
      return response
    },
    async updateCounter({commit}, counter) {
      let response = await Api.request('put', '/pos/updatePosCounter/' + counter.id, counter)
      if (response.data.status === 'SUCCESS') {
        commit('UPDATE_COUNTER', response.data.data)
      }
      return response
    },
    async updateRewardPoint({commit}, reward) {
      let response = await Api.request('put', '/pos/updateRewardPoints/' + reward.id + '/' + this.state.organisationid + '/' + this.getters.userId, reward)
      if (response.data.status === 'SUCCESS') {
        commit('UPDATE_REWARD_POINT', response.data.data)
      }
      return response
    },
    async deleteCounter({commit}, counter) {
      let response = await Api.request('delete', '/pos/deletePosCounter/' + counter.id + '/' + this.getters.userId + '/' + counter.deleteReason)
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_COUNTER', response.data.data)
      }
      return response
    },
    async deleteRewardPoint({commit}, counter) {
      let response = await Api.request('delete', '/pos/deleteRewardPoint/' + counter.id + '/' + this.getters.userId + '/' + counter.deleteReason)
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_REWARD_POINT', response.data.data)
      }
      return response
    },
    // CounterMethods
    async loadDailySalesReport({commit}, date) {
      let response = await Api.request('get', '/pos/posSalesDayWiseReport/' + this.state.organisationid + '/' + this.getters.fyId + '/' + date.fromDate + '/' + this.getters.userId + '/' + date.warehouse)
      if (response.data.status === 'SUCCESS') {
      }
      return response
    },
    async paymentStatusUpdate({commit}, payment) {
      let response = await Api.request('put', '/pos/paymentStatusUpdateByHeaderId/' + payment.id + '/' + this.state.organisationid + '/' + payment.status + '/' + payment.method)
      // if (response.data.status === 'SUCCESS') {
      //
      // }
      return response
    },
    async posSalesDetailBySalesHeaderId({commit}, posDetail) {
      let response = await Api.request('get', '/pos/posSalesDetailBySalesHeaderId/' + this.state.organisationid + '/' +
       posDetail.headerId + '/' + posDetail.itemId)
      return response
    },
    async posSalesBillNo({commit}) {
      let response = await Api.request('get', '/pos/billNumber/' + this.state.organisationid + '/' + this.getters.fyId)
      return response
    },
    async posSalesReturnDetailList({commit}, billNo) {
      let response = await Api.request('get', '/pos/salesDetailByBillNo/' + billNo + '/' + this.getters.organisationId + '/' + this.getters.userId + '/' + this.state.fyId)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async posDetailByBillNo({commit}, billNo) {
      let response = await Api.request('get', '/pos/salesDetailByBillNo/' + billNo + '/' + this.state.organisationid + '/' + this.getters.userId + '/' + this.getters.fyId)
      return response
    },
    async posSalesReturnBillWise({commit}, posSales) {
      let response = await Api.request('post', '/pos/salesReturn/' + posSales.id + '/' + this.state.organisationid + '/' + this.getters.userId, posSales)
      return response
    },
    async loadStockInDetailsHistory({commit}, date) {
      let response = await Api.request('get', '/item/itemInStockHistoryReport/' + date.id + '/' + this.getters.fyId)
      if (response.data.status === 'SUCCESS') {
        commit('ITEM_IN_HISTORY_LIST', response.data.data)
      }
      return response
    },
    async deletePosSales({commit}, deleteRea) {
      let response = await Api.request('delete', '/pos/deletePosSales/' + deleteRea.id + '/' + this.getters.userId + '/' + deleteRea.deleteReason)
      // // debugger
      let deleteSales = response.data.data
      commit('DELETE_POS_SALES', deleteSales)
      return response
    },
    async posCustomerByContactNumber({commit}, contactNumber) {
      let response = await Api.request('get', '/pos/returnPosCustomerByContactNumber/' + this.state.organisationid + '/' + this.getters.userId + '/' + contactNumber)
      return response.data.data
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/pos.js